import { connect } from 'react-redux';
import accessors from './store/accessors';

const connector = connect(mapStateToProps);

export default connector;

function mapStateToProps(state) {
  const debugMode = state.app.debug;
  const isPaused = accessors.app.isPaused(state);
  const { key_codes } = state.device;
  const object = state.video.description;

  return {
    isPaused,
    debugMode,
    keyCodes: key_codes,
    object,
  };
}
